import basicInfo from './productFrom/basicInfo';
import contents from './productFrom/content';
import planList from './productFrom/planList';
import { customerInsuranceDetail } from './request';
export default {
  components: {
    basicInfo,
    contents,
    planList
  },
  data() {
    return {
      activeKey: 1,
      customerInsuranceId: this.$route.params.id,
      disabled: false,
      insuranceId: '',
      mark: '',
      customerId: ''
    };
  },
  created() {
    customerInsuranceDetail({
      customerInsuranceId: this.customerInsuranceId
    }).then(res => {
      this.disabled = res.isGenerateQr ? false : true;
      this.mark = res.insuranceMark;
      this.customerId = res.customerId;
      this.insuranceId = res.insuranceId;
      console.log(this.mark, 2223);
    });
  },
  methods: {
    tabChange(val) {
      this.activeKey = val;
    },
    previousFun() {
      if (this.disabled) {
        this.activeKey = 1;
      } else {
        this.activeKey = 2;
      }
    },
    async nextFun(val) {
      this.activeKey++;
    }
  }
};